// copied from: packages/sub-issues/utils/urls.ts
export const QUERY_FIELDS = {
  label: 'label',
  type: 'type',
  assignee: 'assignee',
} as const
// Returns the repository "scoped" issues search url for the provided metadata
// For example, this is used to generate the search url used when clicking on an issue type token
export const getIssueSearchURL = (
  {owner, repo}: {owner: string; repo: string},
  field: keyof typeof QUERY_FIELDS,
  value: string,
) => {
  if (!owner || !repo) {
    return ''
  }

  const baseUrl = `/${owner}/${repo}/issues`

  if (!field || !value) {
    return baseUrl
  }

  value = value.includes(' ') ? `"${value}"` : value
  const query = encodeURIComponent(`${field}:${value}`)
  return `${baseUrl}?q=${query}`
}

/**
 * Gathers issue link hrefs from a container element.
 *
 * When `matchByHref` is true, matches any anchor whose href contains "/issues/" —
 * this catches issue references that lack the server-rendered "issue-link" class.
 * When false, only matches anchors with the "issue-link" class (original behavior).
 */
export function gatherIssueLinks(container: HTMLElement | null, matchByHref = false): string[] {
  if (!container) return []

  if (matchByHref) {
    const allLinks = container.querySelectorAll<HTMLAnchorElement>('a[href*="/issues/"]')
    const issueUrlPattern = /\/issues\/\d+([/?#].*)?$/
    return Array.from(allLinks)
      .filter(link => issueUrlPattern.test(link.href))
      .map(link => link.href)
  }

  const issueLinks = container.querySelectorAll<HTMLAnchorElement>('a.issue-link')
  return Array.from(issueLinks).map(link => link.href)
}
